/**
 * @module use-cases/order/helpers
 *
 */

import { ORDER_PAYMENT_VIEWS } from 'core/domains';
import type { Order } from 'core/domains';

/**
 * Get payment view
 */
export function getPaymentView(payments: Order['data']['payments']) {
  switch (payments?.length) {
    case 0: {
      return ORDER_PAYMENT_VIEWS.GENERIC;
    }

    case 1: {
      return ORDER_PAYMENT_VIEWS.BOLETO;
    }

    default: {
      return ORDER_PAYMENT_VIEWS.BOLETO_INSTALLMENTS;
    }
  }
}

/**
 * Get payment view CreditCard
 */
export function getPaymentViewCreditCard(data: Order['data']) {
  const { status } = data;

  switch (status) {
    case 'canceled': {
      return ORDER_PAYMENT_VIEWS.CREDIT_CARD_CANCELED;
    }

    case 'paymentProcess': {
      return ORDER_PAYMENT_VIEWS.CREDIT_CARD_PROCESS;
    }

    default: {
      return ORDER_PAYMENT_VIEWS.CREDIT_CARD_PROCESSING;
    }
  }
}
